<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Historial de pagos" }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui encontraras el historial de todos los egresos realizados." }}</div>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col class="d-flex pl-0 py-0">
          <div style="width: 286px;">
            <v-autocomplete
              label="Selecciona un cliente"
              :items="enterprises"
              hide-details
              style="font-family: 'montserrat-medium'; border-radius: 20px;"
              outlined
              clearable
              class="mr-2"
              item-value="sEnterpriseId"
              item-text="sName"
              @change="getPaymentsHistory()"
              v-model="selectedEnterprise"
            ></v-autocomplete>
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#000000" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descarga" }}
          </v-btn>
        </v-col>
      </v-row>
      <!-- <v-row class="ma-0 mb-4">
        <v-col class="d-flex justify-end py-0">
          <div class="d-flex align-center" style="width: fit-content; background: #BFD7ED; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); border-radius: 10px; padding: 15px; border: 1px solid #C5CDD3;">
            <div class="pa-1 mr-3" style="background-color: #ECF6FF; border-radius: 5px;">
              <v-img src="../../assets/icons/trending-up.svg" style="width: 24px;"></v-img>
            </div>
            <div class="mr-1" style="font-family: 'montserrat-semibold';">{{  "Profit: " }}</div>
            <span style="font-family: 'montserrat-bold'" :style="{ color: totalProfit < 0 ? '#0075B8' : '#0075B8'}"> 
              {{ "$ " + formatMoney(totalProfit)  }}
            </span>
          </div>
        </v-col>
      </v-row> -->
      <v-data-table class="d-none d-sm-block" hide-default-header :items="items">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ "Id" }}</th>     
              <th class="header__title center">{{ "Empresa" }}</th>                                                                                                                                                                                    
              <th class="header__title center">{{ "Destinatario" }}</th>
              <th class="header__title center">{{ "Fecha de pago" }}</th>                                                                                                                                                                                                                          
              <th class="header__title center">{{ "Status" }}</th>
              <th class="header__title center">{{ "Tipo de cambio" }}</th>
              <th class="header__title center">{{ "Monto origen" }}</th>
              <th class="header__title center">{{ "Monto destino" }}</th>
              <th class="header__title center">{{ "Monto aplicado" }}</th>
              <th class="header__title center">{{ "Profit ($)" }}</th>
              <th class="header__title center">{{ "Profit (%)" }}</th>
              <th class="header__title right">{{ "Actions" }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.sPaymentId }}</td>
              <td class="table__item">{{ item.CustomerEnterprises }}</td>
              <td class="table__item">{{ item.PaymentRecipient}}</td>
              <td class="table__item">{{ formatDate(item.created_at) }}</td>
              <td class="table__item">
                <v-chip :color="setStatusColor(item.StatusPayments)" class="ma-2" outlined>
                  {{ item.StatusPayments }}
                </v-chip>
              </td>
              <td class="table__item">{{  item.dRate ? "$ " + formatMoney(item.dRate) + " MXN" : "-" }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dPaymentAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dDescAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
            <td class="table__item" :style="parseFloat(item.montoAplicado).toFixed(2) == parseFloat(item.dDescAmount).toFixed(2) ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ "$ " + formatMoney(item.montoAplicado) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
              <td class="table__item" :style="item.dCurrencyGain ? (item.dCurrencyGain >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;') : 'color: black'">{{ item.dCurrencyGain ? "$ " + formatMoney(item.dCurrencyGain) + " USD" : "-" }}</td>
              <td class="table__item" :style="item.dProfitPercentage ? (item.dProfitPercentage >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;') : 'color: black'">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
              <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Detalle</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="getReceipt(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-invoice-text-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar comprobante</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="getCep(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-receipt-text</v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar cep</span>
                  </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ "Id" }}</div>
                <div> {{ item.sPaymentId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Empresa" }}</div>
                <div>{{ item.CustomerEnterprises }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Destinatario" }}</div>
                <div>{{ item.PaymentRecipient }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de pago" }}</div>
                <div>{{ formatDate(item.created_at) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Estatus" }}</div>
                <div>
                  <v-chip  class="ma-2" outlined color="#193D6E">
                    {{ item.StatusPayments }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Tipo de cambio" }}</div>
                <div>{{ "$ " + formatMoney(item.dRate) + " MXN" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto origen" }}</div>
                <div>{{ "$ " + formatMoney(item.dPaymentAmount) + " USD" }}</div>
              </td>
              <td class="table__item__mobile" >
                <div>{{ "Monto destino" }}</div>
                <div>{{ "$ " + formatMoney(item.dDescAmount) + " MXN" }}</div>
              </td>
              <td class="table__item__mobile" >
                <div>{{ "Profit ($)" }}</div>
                <div>{{ "$ " + formatMoney(item.profit)}}</div>
              </td>
              <td class="table__item__mobile" >
                <div>{{ "Profit (%)" }}</div>
                <div>{{ "$ " + formatMoney(item.profitPercentage)}}</div>
              </td>
              <td class="table__item__mobile" >
                <div>{{ "Acciones" }}</div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Detalle</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="getReceipt(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-invoice-text-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar comprobante</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="getCep(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-receipt-text</v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar cep</span>
                  </v-tooltip>
                </div>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
    <PaymentDetailDialog v-model="dialogPaymentDetail" :s-payment-id="selectedPaymentId" />
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import PaymentDetailDialog from "@/components/dialogs/PaymentDetailDialog.vue";

export default {
  name: "DashboardView",
  components: {
    PaymentDetailDialog,
  },
  data() {
    return {
      nameXLSX: "HistorialPagos.xlsx",
      texts: "",
      drawer: null,
      dialogPaymentDetail: false,
      selectedPaymentId: null,
      dialogDetailConversion: false,
      conversion: {},
      actualCurrency: "0",
      actualCurrencyMxn: "0",
      referenceCurrency: "0",
      isLoading: false,
      isRegisterEfex: true,
      exchangeRateData: [],
      selected: [],
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balanceMxn: "0",
      balanceUsd: "0",
      balance: "0",
      items: [],
      tab: 0,
      contacts: [],
      itemsSelected: [],
      itemsSelectedForwards: [],
      isForwardRateCalculated: false,
      bSelectedAll: false,
      dialogAddFoundss: false,
      dialogSendPay: false,
      dialogAddFounds: false,
      dataAddFounds: {},
      dialogCreate: false,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      totalUsd: 0,
      selectedMenuItem: "dashboard",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY"
      },
      isForwardsActive: false,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      isDeferredPayment: false,
      stepper: false,
      e1: 1,
      enterprises: [],
      selectedEnterprise: "",
      timerCount: 30,
      headersForex: [
        this.selectLanguage === 'en' ? { text: "Id", value: "iTrackingId", align: "center", sortable: false} : { text: "Id", value: "iTrackingId", align: "center", sortable: false},
        this.selectLanguage === 'en' ? { text: "Payment date", value: "created_at", align: "center"} : { text: "Fecha de pago", value: "created_at", align: "center"},
        this.selectLanguage === 'en' ? { text: "Recipient", value: "sName", align: "center"} : { text: "Destinatario", value: "sName", align: "center"},
        this.selectLanguage === 'en' ? { text: "Type Transaction", value: "type", align: "center"} : { text: "Tipo de transacción", value: "type", align: "center"},
        this.selectLanguage === 'en' ? { text: "Status", value: "status_sName", align: "center"} : { text: "Estado", value: "status_sName", align: "center"},
        this.selectLanguage === 'en' ? { text: "Total amount USD", value: "dAmount", align: "center"} : { text: "Monto total USD", value: "dAmount", align: "center"},
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dDescAmount", align: "center"} : { text: "Monto total MXN", value: "dDescAmount", align: "center"},
        this.selectLanguage === 'en' ? { text: "Exchange rate", value: "dRate", align: "center"} : { text: "Tasa de cambio", value: "dRate", align: "center"},
        this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center", sortable: false } : { text: "Acciones", value: "actions", align: "center", sortable: false },
      ],
      timerId: null,
      totalProfit: 0,
      dataEfex: {},
      exchangeRateAdjustments: [],
      exchangeRatesStateForwards: [],
      isPayMxn: false,
      bSelectedAllSeparate: false,
      dialogEditProfileActive: false,
      isForwards: false,
      isForwardsPayment: false,
      userName: "",
      modalCurrency: 0,
      loadingTransaction: false,
      miniVariant: true,
      expandOnHover: false,
      transactions: [],
      invoices: []
    };
  },
  methods: {
    getPaymentsHistory() {
      this.isLoading = true;

      const payload = {
        sEnterpriseId: this.selectedEnterprise,
      };

      DB.post(`${URI}/api/v1/en/administrator/payments`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.items = response.data.payments;
        this.totalProfit = 0;
        this.items.forEach((item) => {
          this.totalProfit += parseFloat(item.profit) || 0;
        });
        this.isLoading = false;
      }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getEnterprises() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/en/administrator/enterprises`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.enterprises = response.data.users.map((item) => ({
          sEnterpriseId: item.enterprise.sEnterpriseId,
          sName: item.enterprise.enterprise[0].sName,
        }));
        this.isLoading = false;
      }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Id: item.sPaymentId ? item.sPaymentId : "",
            "Usuario": item.CustomerEnterprises ? item.CustomerEnterprises : "",
            "Destinatario": item.PaymentRecipient ? item.PaymentRecipient : "",
            "Fecha de pago": item.dPaymentDate ? item.dPaymentDate : "",
            "Status": item.StatusPayments ? item.StatusPayments : "",
            "Exchange rate": item.dRate ? item.dRate : "",
            "Monto origen": item.dPaymentAmount ? item.dPaymentAmount : "",
            "Monto destino": item.dDescAmount ? item.dDescAmount : "",
            "currency origen": item.sCurrency ? item.sCurrency : "",
            "currency dest": item.sDestCurrency ? item.sDestCurrency : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    openDetail(item) {
      this.selectedPaymentId = item.sPaymentId;
      this.dialogPaymentDetail = true;
    },
    getReceipt(item) {
      this.loading = true;
      const payload = {
        sPaymentId: item.sPaymentId,
        sEnterpriseId: item.sEnterpriseId,
      };

      DB.post(
        `${URI}/api/v1/en/administrator/getReceipt`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
          responseType: 'blob'
        }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${item.PaymentRecipient + (item.invoice ? "_" + item.invoice : "")}.pdf`;
        link.click();
      })
      .catch((error) => {
        this.mixError(
          error?.response?.data?.message || "No se pudo descargar el archivo",
          error?.response?.status || 500
        );
      })
      .finally(() => {
        this.loading = false;
      });
    },
    getCep(item) {
      this.loading = true;
      const payload = {
        sPaymentId: item.sPaymentId,
        sEnterpriseId: item.sEnterpriseId,
      };

      DB.post(
        `${URI}/api/v1/en/administrator/getCep`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
      .then((response) => {
        const url = response.data.paymentCep;
        if (url) {
          window.open(url, "_blank");
        } else {
          this.mixError("Error al descargar el cep.", 400);
        }
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    setStatusColor: function (status) {
      if (status === "COMPLETED" || status === "DEPOSITED") {
        return "green";
      } else if(status === "PENDING_TO_PROCESS"){
        return "blue";
      } else if(status === "PENDING_TO_DEPOSIT"){
        return "blue";
      } else if(status === "REJECTED"){
        return "red";
      }
       else {
        return "gray";
      }
    },
  },
  beforeMount() {
    this.getPaymentsHistory();
    this.getEnterprises();
  },
};
</script>

<style>
</style>
